/* Creator landing page (ncl-*) — shop-the-look modal, favourites filter,
   mobile sticky CTA, per-ad hero video swap. State machine per the handoff
   README (rows{included,size}, derived totals). Cart add = ONE
   /cart/add.js items[] call, then the nama cart drawer opens (NamaCart).
   Analytics: dataLayer pushes + CustomEvents (look_open / use_her_size /
   piece_toggle / look_added) — the A/B test's measurement hooks. */
(function () {
  var root = document.querySelector('[data-ncl]');
  if (!root) return;

  var dataEl = root.querySelector('[data-ncl-data]');
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { DATA = { looks: [], adVariants: {} }; }

  var money = function (cents) {
    return '$' + Math.round(cents / 100).toLocaleString('en-US');
  };
  var track = function (name, detail) {
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'ncl_' + name }, detail));
      document.dispatchEvent(new CustomEvent('ncl:' + name, { detail: detail }));
    } catch (e) { /* analytics must never break shopping */ }
  };

  /* ── per-ad hero video swap (?ad=key) ─────────────────────────── */
  (function () {
    try {
      var key = new URLSearchParams(location.search).get('ad');
      if (!key) return;
      var src = DATA.adVariants[key.toLowerCase()];
      if (!src) return;
      var vid = root.querySelector('.ncl-banner video');
      if (!vid) return;
      vid.querySelectorAll('source').forEach(function (s) { s.remove(); });
      vid.src = src;
      vid.load();
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
      track('ad_variant', { key: key });
    } catch (e) { /* bad param falls back to the default video silently */ }
  })();

  /* ── video autoplay resilience (same contract as split-hero) ──── */
  var vids = root.querySelectorAll('video');
  vids.forEach(function (v) {
    v.muted = true; v.playsInline = true;
    v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.loop = true;
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.25) {
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) { v.pause(); }
    });
  }, { threshold: [0, 0.25] });
  vids.forEach(function (v) { io.observe(v); });
  ['touchend', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      vids.forEach(function (v) {
        var r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight && v.paused) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
      });
    }, { passive: true });
  });

  /* ── shop-the-look modal ──────────────────────────────────────── */
  var scrim = root.querySelector('[data-ncl-scrim]');
  var sheet = root.querySelector('[data-ncl-sheet]');
  var body = root.querySelector('[data-ncl-sh-body]');
  var label = root.querySelector('[data-ncl-sh-label]');
  var title = root.querySelector('[data-ncl-sh-title]');
  var countEl = root.querySelector('[data-ncl-sh-count]');
  var totalEl = root.querySelector('[data-ncl-sh-total]');
  var codeEl = root.querySelector('[data-ncl-sh-code]');
  var saveEl = root.querySelector('[data-ncl-sh-save]');
  var addBtn = root.querySelector('[data-ncl-sh-add]');
  var noteEl = root.querySelector('[data-ncl-sh-note]');
  var toast = root.querySelector('[data-ncl-toast]');

  var cur = null;   // active look index
  var rows = [];    // [{ included, size }]

  function sizeAxis(item) {
    for (var i = 0; i < item.options.length; i++) {
      if (/size/i.test(item.options[i].name)) return { pos: i, values: item.options[i].values };
    }
    // single-option products: treat the only axis as the chooser
    if (item.options.length === 1) return { pos: 0, values: item.options[0].values };
    return null;
  }
  function sizeAvailable(item, pos, val) {
    return item.variants.some(function (v) { return v.options[pos] === val && v.available; });
  }
  function variantFor(item, k) {
    var ax = sizeAxis(item);
    if (!ax) return item.variants.filter(function (v) { return v.available; })[0] || item.variants[0];
    var want = rows[k].size;
    var match = item.variants.filter(function (v) { return v.options[ax.pos] === want && v.available; })[0];
    return match || null;
  }

  var esc = function (s) { return String(s == null ? '' : s).replace(/</g, '&lt;').replace(/"/g, '&quot;'); };

  function openLook(i) {
    var L = DATA.looks[i];
    if (!L) return;
    cur = i;
    rows = L.items.map(function (it) {
      var ax = sizeAxis(it);
      return { included: true, size: ax ? null : 'one' }; // no axis = nothing to choose
    });
    label.textContent = L.label;
    title.textContent = L.title;
    body.innerHTML = L.items.map(function (it, k) {
      var ax = sizeAxis(it);
      var chips = '';
      if (ax) {
        chips = '<div class="ncl-szs">' + ax.values.map(function (val) {
          var ok = sizeAvailable(it, ax.pos, val);
          return '<button type="button" data-ncl-sz="' + esc(val) + '" aria-pressed="false"' +
            (ok ? '' : ' disabled aria-label="' + esc(val) + ', sold out"') + '>' + esc(val) + '</button>';
        }).join('') + '</div>';
      }
      return '<div class="ncl-it" data-ncl-k="' + k + '">' +
        '<span class="ncl-ph ncl-th"><img src="' + esc(it.image) + '" alt="" loading="lazy"></span>' +
        '<div class="ncl-ic"><div class="ncl-top"><div>' +
        (it.fabric ? '<p class="ncl-fab">' + esc(it.fabric) + '</p>' : '') +
        '<p class="ncl-nm">' + esc(it.name) + '</p></div>' +
        '<span class="ncl-pr">' + money(it.price) + '</span>' +
        '<button class="ncl-inc" type="button" aria-pressed="true" aria-label="Include ' + esc(it.name) + '"><i></i></button>' +
        '</div></div>' + chips + '</div>';
    }).join('');
    sheet.hidden = false;
    sync();
    requestAnimationFrame(function () {
      scrim.classList.add('on');
      sheet.classList.add('on');
      document.body.classList.add('ncl-lock');
    });
    track('look_open', { look: L.title });
  }

  function closeSheet() {
    scrim.classList.remove('on');
    sheet.classList.remove('on');
    document.body.classList.remove('ncl-lock');
    setTimeout(function () { sheet.hidden = true; }, 380);
  }

  function sync() {
    var L = DATA.looks[cur];
    if (!L) return;
    var included = rows.filter(function (r) { return r.included; }).length;
    var total = L.items.reduce(function (a, it, k) { return a + (rows[k].included ? it.price : 0); }, 0);
    var missing = rows.filter(function (r) { return r.included && !r.size; }).length;
    countEl.textContent = included + (included === 1 ? ' piece' : ' pieces');
    totalEl.textContent = included ? money(total) : '—';
    addBtn.disabled = !included || missing > 0;
    addBtn.textContent = included ? 'Add ' + included + ' to bag' : 'Nothing selected';
    if (codeEl) {
      codeEl.style.display = included ? 'flex' : 'none';
      if (saveEl && DATA.discountPercent) saveEl.textContent = 'Save ' + money(Math.round(total * DATA.discountPercent / 100));
    }
    noteEl.textContent = !included ? 'Include at least one piece'
      : missing ? 'Choose a size for ' + missing + (missing === 1 ? ' piece' : ' pieces')
      : 'Free shipping over $150 · 30-day returns';
    Array.prototype.forEach.call(body.children, function (el, k) {
      el.classList.toggle('off', !rows[k].included);
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ncl-look]');
    if (opener) { e.preventDefault(); openLook(+opener.getAttribute('data-ncl-look')); return; }
    if (e.target.closest('[data-ncl-sh-close]') || e.target === scrim) { closeSheet(); return; }

    var sz = e.target.closest('.ncl-szs button');
    if (sz && !sz.disabled && sheet.contains(sz)) {
      var k = +sz.closest('.ncl-it').getAttribute('data-ncl-k');
      rows[k].size = sz.getAttribute('data-ncl-sz');
      sz.parentNode.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      sz.setAttribute('aria-pressed', 'true');
      sync(); return;
    }
    var inc = e.target.closest('.ncl-inc');
    if (inc) {
      var k2 = +inc.closest('.ncl-it').getAttribute('data-ncl-k');
      rows[k2].included = !rows[k2].included;
      inc.setAttribute('aria-pressed', rows[k2].included ? 'true' : 'false');
      track('piece_toggle', { included: rows[k2].included });
      sync(); return;
    }
    if (e.target.closest('[data-ncl-use-hers]')) {
      var her = DATA.herSize;
      if (!her || cur == null) return;
      DATA.looks[cur].items.forEach(function (it, k) {
        var ax = sizeAxis(it);
        if (!ax) return;
        if (!sizeAvailable(it, ax.pos, her)) return; // skip sold-out, per spec
        rows[k].size = her;
        var row = body.children[k];
        row.querySelectorAll('.ncl-szs button').forEach(function (x) {
          x.setAttribute('aria-pressed', x.getAttribute('data-ncl-sz') === her ? 'true' : 'false');
        });
      });
      track('use_her_size', { size: her });
      sync(); return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet.classList.contains('on')) closeSheet();
  });

  addBtn.addEventListener('click', function () {
    if (addBtn.disabled || cur == null) return;
    var L = DATA.looks[cur];
    var items = [];
    L.items.forEach(function (it, k) {
      if (!rows[k].included) return;
      var v = variantFor(it, k);
      if (v) items.push({ id: v.id, quantity: 1 });
    });
    if (!items.length) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      closeSheet();
      toast.textContent = items.length + (items.length === 1 ? ' piece' : ' pieces') + ' added to your bag';
      toast.classList.add('on');
      setTimeout(function () { toast.classList.remove('on'); }, 2600);
      track('look_added', { look: L.title, pieces: items.length });
      if (window.NamaCart) window.NamaCart.open();
    }).catch(function () {
      addBtn.disabled = false;
      addBtn.textContent = 'Try again';
      noteEl.textContent = 'Something went wrong — please try again';
    });
  });

  /* ── card meta: swap the swatch row for her credit ────────────── */
  /* Shane 2026-07-31: colour dots are noise on a creator page — that slot
     becomes "<avatar> Mariana's pick". Done in JS because the swatch row is
     rendered inside the shared product-thumbnail snippet; if this fails the
     swatches simply remain (graceful). */
  (function () {
    var first = DATA.creatorFirst;
    if (!first) return;
    var avatar = DATA.avatar;
    root.querySelectorAll('.ncl-card').forEach(function (card) {
      var slot = card.querySelector('.cross-product-swatches');
      var meta = document.createElement('span');
      meta.className = 'ncl-meta';
      meta.innerHTML = (avatar ? '<img src="' + avatar + '" alt="" loading="lazy" width="44" height="44">' : '') +
        '<span>' + first.replace(/</g, '&lt;') + '\u2019s pick</span>';
      if (slot) { slot.parentNode.replaceChild(meta, slot); }
      else {
        var cap = card.querySelector('.thumbnail__caption');
        if (cap) cap.insertBefore(meta, cap.firstChild);
      }
    });
  })();

  /* ── favourites filter (show/hide, no re-render) ──────────────── */
  var filt = root.querySelector('[data-ncl-filt]');
  if (filt) {
    filt.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-ncl-cat]');
      if (!b) return;
      var cat = b.getAttribute('data-ncl-cat');
      filt.querySelectorAll('button').forEach(function (x) {
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      root.querySelectorAll('[data-ncl-ptype]').forEach(function (card) {
        card.classList.toggle('ncl-hide', cat !== 'All' && card.getAttribute('data-ncl-ptype') !== cat);
      });
    });
  }

  /* ── mobile sticky CTA — after the hero CTA scrolls off the top ── */
  var sticky = root.querySelector('[data-ncl-sticky]');
  var heroCta = root.querySelector('[data-ncl-hero-cta]');
  if (sticky && heroCta) {
    new IntersectionObserver(function (en) {
      sticky.classList.toggle('on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(heroCta);
  }
})();
